import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Settings from './Settings/Settings';
import { styles } from '../styles/dashboard-styles';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import uuid from 'uuid/v1'
class Drawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { left: false }
  }
  toggleDrawer = (side, open) => () => {
      this.setState({
        [side]: open,
      });
    };
  render() {
    const { classes } = this.props; 
    return(
      <SwipeableDrawer
        onOpen={this.toggleDrawer('left', true)}
        open={this.props.open}
        onClose={this.toggleDrawer('left', false)}
      >
        <div className={classes.drawerHeader}>
          <Typography
            component="h2"
            variant="h6"
          >
            Display Settings
          </Typography>
          <IconButton onClick={this.props.drawerClose}>
            <CloseIcon />
          </IconButton>
        </div>
        <Divider />
        <Settings
          onApplySettings={this.props.onApplySettings}
          monitorId={this.props.monitorId}
          rangeSetting={this.props.rangeSetting}
          chartType={this.props.chartType}
          refreshRate={this.props.refreshRate}
          scale={this.props.scale}
          domainMin={this.props.domainMin}
          domainMax={this.props.domainMax}
          layout={this.props.layout}
          cols={this.props.cols}
          dataMapContainer={this.props.dataMapContainer}
          onChange={this.props.onChange}
          onSiteChange={this.props.onSiteChange}
          key={uuid()}
        />
      </SwipeableDrawer>
    )
  }
}


Drawer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Drawer);



// WEBPACK FOOTER //
// ./src/components/Drawer.js